import { render, staticRenderFns } from "./AddSanciones.vue?vue&type=template&id=2dc078c6"
import script from "./AddSanciones.vue?vue&type=script&lang=js"
export * from "./AddSanciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports